import { Color } from './color';
/**
 * ⭓
 */
export var Hexagon = function Hexagon(options, context) {
  return Color(Object.assign({
    colorAttribute: 'fill',
    symbol: 'hexagon'
  }, options), context);
};
Hexagon.props = Object.assign({
  defaultMarker: 'hexagon'
}, Color.props);